import FinishedJourneyCard from './container';

export default FinishedJourneyCard;
